import { toast, ToastContentProps, ToastOptions } from 'react-toastify'
import classNames from 'classnames'

export const CustomToast = (title: string, type: string, body: string, closeDuration:false|number = 5000) => {
  const toastObject: ToastOptions = {
    position: 'top-right',
    autoClose: closeDuration,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    closeButton: true,
  }

  const Msg = ({ closeToast, toastProps }: Partial<ToastContentProps>) => {
    return (
      <>
        <div
          className={classNames('d-flex toastBorder', {
            toastBorder__info: type === 'info',
            toastBorder__danger: type === 'danger',
          })}
        >
          <div className='p-2 toastIcon'>
            {type === 'info' && (<i className="bi bi-info-lg"></i>)}
            {type === 'success' && (<i className="bi bi-check-lg"></i>)}
            {type === 'danger' && (<i className="bi bi-exclamation-triangle"></i>)}
          </div>
          <div className='flex-grow-1 d-flex flex-column flex-md-column px-3'>
            <div className='toastHeader toast_header'>{title}</div>
            <div className='toastMessages'>{body}</div>
          </div>
        </div>
      </>
    )
  }

  toast(<Msg />, toastObject)
}
